export const enum JwtTokenServiceEvent {
  refreshTokenFailed = 'refresh-token-failed',
  refreshTokenStart = 'refresh-token-start',
  refreshTokenSucceeded = 'refresh-token-succeeded',
  tokenSet = 'token-set',
  tokenReset = 'token-reset',
}
